import cn from 'classnames';

import { toShortNumFormat } from '@/common/lib/toShortNumFormat';
import { fixResourceArenaOffer } from '@/redux/reducers/shopReducer';
import { useAppDispatch } from '@/redux/store';

import { Picture } from '../Picture/Picture';

import css from './style.module.scss';

import shufleLock from '/img/icons/custom_contract/shufleLock.png';
import patternPng from '/img/patterns/stars-sm.png';
import patternWebp from '/img/patterns/stars-sm.webp';

const RewardBlockItems = ({
  label,
  value,
  icon,
  variant,
  order,
  offerId,
  fixed,
}: {
  label: string;
  value: number;
  icon: { png: string; webp?: string } | null;
  variant: 'big' | 'medium' | 'small' | 'huge';
  order?: number;
  offerId?: string;
  fixed?: boolean;
}): JSX.Element => {
  const dispatch = useAppDispatch();
  const isPremiumRewards = ['tgem', 'dice', 'vip', 'vipDays'].includes(label);

  const fixResourse = (): void => {
    if (!offerId || !order) return;
    dispatch(fixResourceArenaOffer({ id: offerId, order }));
  };

  return (
    <div
      key={value}
      className={cn(
        css.rewardItem,
        variant === 'big' && css.bigRewardItem,
        css[variant],
      )}
      onClick={fixResourse}
    >
      {fixed && offerId && (
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[5]">
          <img src={shufleLock} className="w-8" alt="lock" />
        </div>
      )}
      {isPremiumRewards && (
        <div className="absolute w-full h-full top-0 left-0">
          <div
            className={cn(css.colorBG, {
              [css.purple]: ['tgem', 'dice'].includes(label),
              [css.gold]: ['vip', 'vipDays'].includes(label),
            })}
          ></div>

          <div
            className={cn(css.topEllipse, {
              [css.purple]: ['tgem', 'dice'].includes(label),
              [css.gold]: ['vip', 'vipDays'].includes(label),
            })}
          ></div>
          <Picture
            className="w-full h-full block aspect-square"
            img={patternPng}
            webp={patternWebp}
            alt="stars"
          />
          {/* <div className="absolute w-[200%] h-[200%] z-[2] top-[-80%] -translate-x-1/2 left-1/2">
            <picture>
              <img src={bgDice} className="!w-full" alt="lock" />
            </picture>
          </div> */}
        </div>
      )}
      {icon && (
        <Picture
          className={cn(
            ['vip', 'vipDays'].includes(label) && '!w-full',
            fixed && offerId && 'opacity-[0.5]',
            css.mainPicture,
          )}
          img={icon.png}
          webp={icon.webp}
          alt={label}
        />
        // <picture>
        //   {icon.webp && <source srcSet={icon.webp} type="image/webp" />}
        //   <img
        //     src={icon.png}
        //     alt={`${label} icon`}
        //     className={cn(
        //       label === 'vip' && '!w-full',
        //       fixed && offerId && 'opacity-[0.5]',
        //     )}
        //   />
        // </picture>
      )}
      <span className={css[`value-${variant}`]}>
        {toShortNumFormat(value)}
        {['vip', 'vipDays'].includes(label) && 'D'}
      </span>
    </div>
  );
};

export default RewardBlockItems;
